import type { ReactNode } from 'react';
import { Text } from '@billda/design-system';

interface LabelValueRowProps {
  label: string;
  value: ReactNode;
  valueWeight?: 'normal' | 'medium';
}

export function LabelValueRow({
  label,
  value,
  valueWeight = 'normal',
}: LabelValueRowProps) {
  return (
    <div className="flex items-center justify-between">
      <Text variant="body2" color="secondary">
        {label}
      </Text>
      <Text
        variant="body1"
        className={valueWeight === 'medium' ? 'font-medium' : undefined}
      >
        {value}
      </Text>
    </div>
  );
}
